import { Component, OnInit } from '@angular/core';
import { ShopService } from '../../services/shop.service';

@Component({
  selector: 'app-clientes',
  templateUrl: './clientes.component.html',
  styleUrls: ['./clientes.component.scss']
})
export class ClientesComponent implements OnInit {

  lista: any;
  clienteData: any
  nombre: string;
  telefono: string;
  direccion: string;
  departamento: string;
  ciudad: string;
  constructor(private shopSvc: ShopService) { }

  ngOnInit(): void {
    this.shopSvc.listClientActive()
                .subscribe(list => {
                  this.lista = list;
                  console.log(this.lista);

                });
  }

  datosCliente(datos: any){
    this.clienteData = datos;
    this.nombre = datos.nombre;
    this.telefono = datos.telefono;
    this.direccion = datos.direccion;
    this.departamento = datos.departamento;
    this.ciudad = datos.ciudad;
  }

}
